import React from 'react'

import { Grid, TextField } from '@material-ui/core'
import { Controller } from 'react-hook-form'

import { AutocompleteTypeAndSearch, Select } from 'components'

const NcGeneralFields = ({
  control,
  errors,
  isShow,
  departments,
  priorityOptions,
  responseUsers,
}) => {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Controller
            as={
              <TextField
                label="Título *"
                fullWidth
                variant="outlined"
                error={!!errors.title}
                helperText={errors?.title?.message}
              />
            }
            control={control}
            name="title"
            disabled={isShow}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <AutocompleteTypeAndSearch
            textField={{
              label: 'Responsável *',
              variant: 'outlined',
              error: !!errors?.responsibleId,
              helperText: errors?.responsibleId?.message,
            }}
            requestToLoadOptions={responseUsers}
            name="responsibleId"
            disabled={isShow}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Controller
            as={
              <Select
                label="Prioridade *"
                fieldValue="value"
                fieldName="name"
                items={priorityOptions}
                error={!!errors?.priority}
                helperText={errors?.priority?.message}
              />
            }
            name="priority"
            control={control}
            defaultValue=""
            onChange={([event]) => event.target.value}
            disabled={isShow}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Controller
            as={
              <Select
                label="Departamento"
                fieldValue="id"
                fieldName="name"
                items={departments}
                error={!!errors?.departmentId}
                helperText={errors?.departmentId?.message}
              />
            }
            name="departmentId"
            control={control}
            defaultValue=""
            onChange={([event]) => event.target.value}
            disabled={isShow}
          />
        </Grid>

        <Grid item xs={12}>
          <Controller
            as={
              <TextField
                label="Descrição"
                fullWidth
                variant="outlined"
                multiline
                minRows={3}
                error={!!errors.description}
                helperText={errors?.description?.message}
              />
            }
            control={control}
            name="description"
            disabled={isShow}
          />
        </Grid>

        <Grid item xs={12}>
          <Controller
            as={
              <TextField
                label="Objetivo"
                fullWidth
                variant="outlined"
                multiline
                minRows={3}
                error={!!errors.objective}
                helperText={errors?.objective?.message}
              />
            }
            control={control}
            name="objective"
            disabled={isShow}
          />
        </Grid>
      </Grid>
    </>
  )
}

export default NcGeneralFields
